import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { action, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../ReactComponent';
import { Cancel } from '@mui/icons-material';

class DialogComplementoAnotacao extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            handleCloseDialog: action
        });
    }

    handleCloseDialog = () => {
        this.salaSessaoStore.dialogComplementoAnotacoesOpen = false;
    };

    render() {
        return (
            <Dialog
                open={this.salaSessaoStore.dialogComplementoAnotacoesOpen}
                onClose={this.handleCloseDialog}
                maxWidth="xl"
                style={{ zIndex: 99999 }}
            >
                <DialogTitle>Anotação</DialogTitle>
                <DialogContent>
                    <Box
                        sx={{ border: '1px solid black', p: 1, borderRadius: 1, minWidth: '600px', minHeight: '400px' }}
                    >
                        <Typography
                            component="pre"
                            sx={{ whiteSpace: 'pre-wrap' }}
                        >
                            {this.salaSessaoStore.dialogConteudoComplementoAnotacoes}
                        </Typography>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={this.handleCloseDialog}
                        color="secondary"
                        variant="outlined"
                        endIcon={<Cancel />}
                        sx={{ mr: 2 }}
                    >
                        Fechar
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default inject('stores')(observer(DialogComplementoAnotacao));
